const setURLParams = (object: string[][]): void => {
  if ('URLSearchParams' in window) {
    const qs = new URLSearchParams(object);
    window.history.replaceState(object, '', `?${qs}`);
  }
};

export default setURLParams;
